import React from 'react';
import MuiGrid from '@mui/material/Unstable_Grid2';

const Grid = React.forwardRef((props, ref) => <MuiGrid {...props} ref={ref} />);

export default Grid;
